import { useState } from 'react';
import propTypes from 'prop-types';
import {
  MdInfo,
  MdCheckCircle,
  MdErrorOutline,
  MdWarningAmber,
} from 'react-icons/md';
import Flex from '../Flex';
import Text from '../Text';
import * as S from './styles';

const variantIconMap = {
  success: MdCheckCircle,
  info: MdInfo,
  danger: MdErrorOutline,
  attention: MdWarningAmber,
  warning: MdWarningAmber,
};

function CollapsibleAlert({
  variant,
  title,
  children,
  defaultExpanded,
  seeMoreLabel,
  seeLessLabel,
  ...props
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const Icon = variantIconMap[variant] || variantIconMap.warning;

  const handleToggle = () => {
    setExpanded(prev => !prev);
  };

  return (
    <S.Container variant={variant} {...props}>
      <S.Header onClick={handleToggle}>
        <Flex alignItems="center" gridGap="8px">
          <Icon size={20} />
          {title && (
            <Text fontSize="14px" fontWeight="600" lineHeight="16px">
              {title}
            </Text>
          )}
        </Flex>

        {(seeMoreLabel || seeLessLabel) && (
          <Flex alignItems="center" gridGap="4px">
            <Text fontSize="12px" fontWeight="600">
              {expanded ? seeLessLabel : seeMoreLabel}
            </Text>
          </Flex>
        )}
      </S.Header>

      <S.Body expanded={expanded}>{children}</S.Body>
    </S.Container>
  );
}

CollapsibleAlert.propTypes = {
  variant: propTypes.oneOf([
    'warning',
    'info',
    'success',
    'danger',
    'attention',
  ]),
  title: propTypes.node,
  children: propTypes.node,
  defaultExpanded: propTypes.bool,
  seeMoreLabel: propTypes.node,
  seeLessLabel: propTypes.node,
};

CollapsibleAlert.defaultProps = {
  variant: 'warning',
  title: null,
  children: null,
  defaultExpanded: false,
  seeMoreLabel: null,
  seeLessLabel: null,
};

export default CollapsibleAlert;
